/**
 * Branded public usage-limit / credential messages (B4.3).
 */
import { del, get, put } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface UsageLimitMessageCatalogEntry {
  code: string;
  defaultMessage: string;
  label: string;
}

export interface UsageLimitMessageOverride {
  id: string;
  tenantId: string;
  agentId: string | null;
  errorCode: string;
  message: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertUsageLimitMessagePayload {
  agentId?: string | null;
  errorCode: string;
  message: string;
}

function toQuery(agentId?: string | null): string {
  if (!agentId) return '';
  return `?agentId=${encodeURIComponent(agentId)}`;
}

export const usageLimitMessagesService = {
  catalog(): Promise<UsageLimitMessageCatalogEntry[]> {
    return get(endpoints.usageLimitMessages.catalog);
  },

  list(agentId?: string | null): Promise<UsageLimitMessageOverride[]> {
    return get(`${endpoints.usageLimitMessages.list}${toQuery(agentId)}`);
  },

  upsert(
    payload: UpsertUsageLimitMessagePayload,
  ): Promise<UsageLimitMessageOverride> {
    return put(endpoints.usageLimitMessages.upsert, payload);
  },

  remove(id: string): Promise<void> {
    return del(endpoints.usageLimitMessages.remove(id));
  },
};
